import React, { useRef, useState } from 'react';
import { CONFIG } from 'config/config';

import Slide from '@material-ui/core/Slide';
import { createTheme } from '@material-ui/core/styles';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import CloseIcon from '@material-ui/icons/Close';
import { isMobile } from 'react-device-detect';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import styled from 'styled-components/macro';
import { Button, Text, View } from '@coinscrap/webapp-core';
import { MainButton } from '../MainButton/MainButton';

const DocViewHeader = styled.div`
	display: flex;
	flex-direction: column;
	position: relative;
	width: 100%;
	justify-content: center;
	align-items: center;
	padding: 24px;
	background-color: ${CONFIG.colors.primaryLighter};
`;
const DocViewFooter = styled.div`
	display: flex;
	position: relative;
	width: 100%;
	justify-content: center;
	align-items: center;
	padding: 16px;
	margin-top: 30px;
	margin-bottom: 20px;
`;

const DocView = (props) => {
	const [numPages, setNumPages] = useState(null);

	const docRef = useRef();

	function onDocumentLoadSuccess({ numPages }) {
		setNumPages(numPages);
	}

	let backgroundImage = 'url(/images/bg_body.png)';
	if (props.styleType === 'white') {
		backgroundImage = '';
	}

	const theme = createTheme({
		overrides: {
			MuiDialog: {
				paper: {
					background: backgroundImage,
				},
			},
		},
	});

	return (
		<View
			justifyStartSt
			style={{
				position: 'relative',
				height: isMobile ? 400 : '100%',
				overflow: isMobile ? 'scroll' : 'hidden',
				backgroundColor: '#fff',
			}}
		>
			<DocViewHeader>
				<Text headingPrimarySt style={{ fontSize: '26px', marginBottom: 5 }}>
					{props.title}
				</Text>
				{!isMobile && (
					<View rowSt style={{}}>
						Lee todo el documento antes de continuar
					</View>
				)}
				<ArrowForwardIosIcon
					onClick={() => {
						docRef.current.scrollIntoView({ behavior: 'smooth' });
					}}
					style={{
						position: 'absolute',
						top: isMobile ? 30 : 30,
						right: isMobile ? 15 : 30,
						width: isMobile ? 30 : 45,
						height: 'auto',
						transform: 'rotate(90deg)',
						opacity: 1,
						cursor: 'pointer',
						fill: CONFIG.colors.primary,
						display: numPages === null ? 'none' : undefined,
					}}
				></ArrowForwardIosIcon>
			</DocViewHeader>
			<Document
				className={'docViewDoc'}
				loading={'Cargando documento...'}
				error={'Ha ocurrido un error al cargar el documento.'}
				file={{ url: props.url }}
				onLoadSuccess={onDocumentLoadSuccess}
			>
				{[...Array(numPages).keys()].map((p, index) => (
					<Page
						key={`PDF_page_${index}`}
						className={'docViewPage'}
						loading={'Cargando página...'}
						error={'Ha ocurrido un error al cargar la página.'}
						pageNumber={p + 1}
						width={isMobile ? 300 : 1000}
					/>
				))}
			</Document>
			<View style={{ height: 10 }}>
				<View ref={docRef} />
			</View>

			<DocViewFooter>
				<MainButton
					disabled={numPages === null}
					onClick={() => props.onClose()}
					style={{ width: '90%' }}
				>
					Marcar como leído
					<CloseIcon style={{ marginLeft: 10 }} />
				</MainButton>
			</DocViewFooter>
		</View>
	);
};

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

export default DocView;
